import { z } from 'zod';

export const dashboardAnalyticsSchema = z.object({
  applicationsPendingReview: z.number(),
  applicationAverageReactionTime: z.number(),
  checkoutsPendingReview: z.number(),
  checkoutsAverageAcceptenceTime: z.number(),
  fillRateOfUpcomingShifts: z.number(),
  fillRateForFlexPoolWorkers: z.number(),
  daysPlannedAhead: z.number(),
  medianShiftPublishingWindow: z.number(),
});

export type DashboardAnalyticsResponse = z.infer<typeof dashboardAnalyticsSchema>;

export const dashboardTodoSchema = z.object({
  notPlannedWork: z.boolean().optional(),
  fullFillYourWork: z.array(z.string()).optional(),
  openCheckouts: z.number().optional(),
});

export type DashboardTodoResponse = z.infer<typeof dashboardTodoSchema>;

export const shiftOverviewChartResponseSchema = z.array(
  z.object({
    label: z.string(),
    value: z.number(),
  })
);

export type ShiftOverviewChartResponse = z.infer<typeof shiftOverviewChartResponseSchema>;

export const IntervalSchema = z.enum(['daily', 'weekly', 'monthly']);
export type Interval = z.infer<typeof IntervalSchema>;
